import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const fileWriteUiNodeSpec: UiNodeSpec<'fileWrite'> = {
    requiredSockets: () => ({
        conditionallyRequired: [],
        required: [ 'trigger', 'filePath', 'fileContents' ],
    }),
    cfg: () => ({
        controlValues: { encoding: 'utf-8', append: false, createIfNotExists: true },
        id: getUID(),
        kind: 'fileWrite',
        disabled: false,
    }),
    controls: getNodeCfg => ({
        encoding: {
            cfg: {
                items: [
                    { label: 'UTF-8', value: 'utf-8' },
                    { label: 'ASCII', value: 'ascii' },
                    { label: 'Latin1', value: 'latin1' },
                    { label: 'UTF-16 LE', value: 'utf16le' },
                    { label: 'Base64', value: 'base64' },
                    { label: 'Hex', value: 'hex' },
                ],
                kind: 'selection',
                label: 'Encoding',
            },
            nodeCfg: getNodeCfg(),
            value: getNodeCfg().controlValues.encoding,
        },
        append: {
            cfg: {
                kind: 'boolean',
                label: 'Append',
            },
            nodeCfg: getNodeCfg(),
            value: getNodeCfg().controlValues.append,
        },
        createIfNotExists: {
            cfg: {
                kind: 'boolean',
                label: 'Create if not exists',
            },
            nodeCfg: getNodeCfg(),
            value: getNodeCfg().controlValues.createIfNotExists,
        },
    }),
    inputs: () => ({
        trigger: {
            socket: 'event',
            label: 'Trigger',
        },
        filePath: {
            socket: 'string',
            label: 'File Path',
        },
        fileContents: {
            socket: 'string',
            label: 'File Contents',
        },
    }),
    kindLabel: 'File Write',
    nodeCategory: 'external',
    outputs: () => ({
        next: {
            socket: 'event',
            label: 'Next',
        },
    }),
    validator: () => true,
};
